import type { TimeDepositActions, PayloadType } from "./types";

export const fetchTimeDepositRates = (): TimeDepositActions => ({
  type: "REQUEST_TIME_DEPOSIT_DATA",
});

export const fetchTimeDepositRatesSuccess = (
  payload: PayloadType
): TimeDepositActions => ({
  type: "REQUEST_TIME_DEPOSIT_SUCCESS",
  payload,
});

export const fetchTimeDepositRateFailed = (): TimeDepositActions => ({
  type: "REQUEST_TIME_DEPOSIT_FAILED",
});

export const refreshTimeDeposit = (): TimeDepositActions => ({
  type: "REFRESH_TIME_DEPOSIT",
});
